module.exports = __webpack_public_path__ + "images/koga0e26431fb45332447029b8f8af7ec448.png";